function forms() {

    if (!!$('form.key-validate').length) {

      var key = getUrlParam('key');
      if (key) {
        $('#key').val(key);
        $('.key-validate').trigger('submit');
      }

      $('form.key-validate').validate();
    }

    if (!!$('form.esignup').length) {
      $('form.esignup').validate();
    }

    if ($('form.validate').length) {

      // Get Updates
      $.validator.addClassRules({
        birthMonth: {
        required: true,
        digits: true,
        range: [1, 12],
        minlength: 2,
        maxlength: 2
        },
        birthDay: {
        required: true,
        digits: true,
        range: [1, 31],
        minlength: 2,
        maxlength: 2
        },
        birthYear: {
        required: true,
        digits: true,
        range: [1900, 2050],
        minlength: 4,
        maxlength: 4
        }

      });


      $('.update-options input').prop("checked", true);

      $('form.validate').validate();

    }

    if (!!$('.autosub').length) {
      setTimeout(function(){
        $('#mc-embedded-subscribe-form').trigger('submit');
      }, 1500);
    }


};